import { render, staticRenderFns } from "./AliasSettings.vue?vue&type=template&id=b4dfa1e6&scoped=true"
import script from "./AliasSettings.vue?vue&type=script&lang=js"
export * from "./AliasSettings.vue?vue&type=script&lang=js"
import style0 from "./AliasSettings.vue?vue&type=style&index=0&id=b4dfa1e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dfa1e6",
  null
  
)

export default component.exports